/* =============================================================================
   CANNUMO 3.0 — theme.js (core)
   Lightweight, dependency-free. Feature modules are loaded per-section.
   ============================================================================= */
(function () {
  "use strict";

  // Flip no-js -> js as early as possible (class set on <html> in the head).
  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* --- Scrollbar width ------------------------------------------------------
     100vw counts the scrollbar; --sbw lets CSS subtract it so full-bleed
     carousels land exactly on the screen edge instead of under the scrollbar. */
  function measureScrollbar() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--sbw", (sbw > 0 ? sbw : 0) + "px");
  }
  measureScrollbar();
  window.addEventListener("resize", measureScrollbar);

  /* --- Scroll reveal ------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Optional stagger: [data-reveal-stagger] on a parent staggers children.
        el.classList.add("is-in");
        obs.unobserve(el);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.1 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Staggered children -------------------------------------------------- */
  function initStagger() {
    document.querySelectorAll("[data-reveal-stagger]").forEach(function (group) {
      var step = parseFloat(group.getAttribute("data-reveal-stagger")) || 0.08;
      Array.prototype.forEach.call(group.querySelectorAll("[data-reveal]"), function (el, i) {
        el.style.setProperty("--reveal-delay", (i * step) + "s");
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* --- Generic carousel arrows -------------------------------------------- */
  // Any [data-carousel] wrapping a [data-carousel-track] + [data-carousel-prev/next].
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-carousel-prev],[data-carousel-next]");
    if (!btn) return;
    var wrap = btn.closest("[data-carousel]");
    var track = wrap && wrap.querySelector("[data-carousel-track]");
    if (!track) return;
    var dir = btn.hasAttribute("data-carousel-next") ? 1 : -1;
    // Step exactly one card (card width + gap); fall back to ~a screenful.
    var card = track.firstElementChild;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
    // Loop: next past the last card wraps to the first; prev before the first wraps to the last.
    var maxLeft = track.scrollWidth - track.clientWidth;
    if (dir > 0 && track.scrollLeft >= maxLeft - 2) {
      track.scrollTo({ left: 0, behavior: "smooth" });
    } else if (dir < 0 && track.scrollLeft <= 2) {
      track.scrollTo({ left: maxLeft, behavior: "smooth" });
    } else {
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    }
  });

  /* Show carousel arrows only when the track actually overflows its container. */
  function updateCarouselNav() {
    var wraps = document.querySelectorAll("[data-carousel]");
    for (var i = 0; i < wraps.length; i++) {
      var track = wraps[i].querySelector("[data-carousel-track]");
      if (!track) continue;
      wraps[i].classList.toggle("is-scrollable", track.scrollWidth > track.clientWidth + 2);
    }
  }
  var cnavRAF;
  function scheduleCarouselNav() { cancelAnimationFrame(cnavRAF); cnavRAF = requestAnimationFrame(updateCarouselNav); }
  window.addEventListener("resize", scheduleCarouselNav);
  window.addEventListener("load", updateCarouselNav);
  if (document.readyState !== "loading") updateCarouselNav();
  else document.addEventListener("DOMContentLoaded", updateCarouselNav);

  /* PDP ingredients accordion: custom flavour dropdown (styleable, unlike a native <select>). */
  function closeIngrDD(dd) {
    dd.classList.remove("is-open");
    var b = dd.querySelector("[data-ingr-dd-btn]"); if (b) b.setAttribute("aria-expanded", "false");
    var l = dd.querySelector("[data-ingr-dd-list]"); if (l) l.hidden = true;
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ingr-dd-btn]");
    var opt = e.target.closest("[data-ingr-dd-opt]");
    var openDD = document.querySelectorAll("[data-ingr-dd].is-open");
    for (var i = 0; i < openDD.length; i++) {
      if (btn && openDD[i].contains(btn)) continue;
      if (opt && openDD[i].contains(opt)) continue;
      closeIngrDD(openDD[i]);
    }
    if (btn) {
      var dd = btn.closest("[data-ingr-dd]");
      if (dd.classList.contains("is-open")) { closeIngrDD(dd); }
      else { dd.classList.add("is-open"); btn.setAttribute("aria-expanded", "true"); var l = dd.querySelector("[data-ingr-dd-list]"); if (l) l.hidden = false; }
      return;
    }
    if (opt) {
      var ddo = opt.closest("[data-ingr-dd]");
      var box = opt.closest("[data-ingr]");
      var opts = ddo.querySelectorAll("[data-ingr-dd-opt]");
      for (var j = 0; j < opts.length; j++) opts[j].classList.toggle("is-sel", opts[j] === opt);
      var label = ddo.querySelector("[data-ingr-dd-label]"); if (label) label.textContent = opt.getAttribute("data-name") || "";
      var txt = box.querySelector("[data-ingr-text]");
      if (txt) { var _v = opt.getAttribute("data-ingredients") || "", _d = document.createElement("div"); _d.textContent = _v; txt.innerHTML = _d.innerHTML.replace(/oat flakes/gi, function (m) { return "<strong>" + m + "</strong>"; }); }
      var fat = box.querySelector("[data-ingr-fat]"); if (fat) fat.textContent = opt.getAttribute("data-fat") || "";
      closeIngrDD(ddo);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var openDD = document.querySelectorAll("[data-ingr-dd].is-open");
    for (var i = 0; i < openDD.length; i++) closeIngrDD(openDD[i]);
  });

  /* --- Mobile menu --------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var menu = document.getElementById("mobile-menu");
    if (!menu) return;
    if (e.target.closest("[data-menu-toggle]")) {
      menu.classList.add("is-open");
      document.body.style.overflow = "hidden";
    } else if (e.target.closest("[data-menu-close]") || e.target === menu) {
      menu.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var menu = document.getElementById("mobile-menu");
    if (menu && menu.classList.contains("is-open")) {
      menu.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  });

  ready(function () {
    initStagger();
    initReveal();
  });

  // Expose a tiny namespace for section modules.
  window.Cannumo = window.Cannumo || {};
  window.Cannumo.reduceMotion = reduceMotion;
})();
